export const DRIVE = 'DRIVE';
export const DROPBOX = 'DROPBOX';
export const BOX = 'BOX';
export const FILE_MANAGER = 'FILE_MANAGER';

// TOOD: switch refs of ImportTypes to this and remove constants on line 1-4
export const IMPORT_TYPES = {
  DRIVE: 'DRIVE',
  DROPBOX: 'DROPBOX',
  BOX: 'BOX',
  FILE_MANAGER: 'FILE_MANAGER'
};